import React from "react";
import StatusFormatter from "../Components/StatusForatter/StatusFormatter";
import DeleteCustomer from "../Screens/Dashboard/Customers/components/DeleteCustomer/DeleteCustomer";
import EditCustomer from "../Screens/Dashboard/Customers/components/EditCustomer/EditCustomer";
import CountryFormatter from "../Components/CountryFormatter/CountryFormatter";
import TagFormatter from "../Components/TagFormatter/TagFormatter";
import EditTori from "../Screens/Dashboard/Properties/Tori/components/EditTori/EditTori";
import RokubRowEditor from "../Screens/Dashboard/Properties/Rokub/components/RokubRowEditor/RokubRowEditor";
import FomMastikRowEditor from "../Screens/Dashboard/Properties/FomMastik/components/FomMastikRowEditor/FomMastikRowEditor";
import EditRowKhedmat from "../Screens/Dashboard/Properties/Khadamat/components/EditRowKhedmat/EditRowKhedmat";
import { Type } from "react-bootstrap-table2-editor";
import MahdoodeRowEditor from "../Screens/Dashboard/Properties/Yaragh/components/MahdoodeRowEditor/MahdoodeRowEditor";
import HingedEditDialog from "../Screens/Dashboard/Olgo/EditOlguDialog/HingedEditDialog";
import DeleteTori from "../Screens/Dashboard/Properties/Tori/components/DeleteTori/DeleteTori";
import DeleteMahsooleShishe from "../Screens/Dashboard/Properties/Shishe/components/DeleteMahsooleShishe/DeleteMahsooleShishe";
import DeleteRokub from "../Screens/Dashboard/Properties/Rokub/components/DeleteRokub/DeleteRokub";
import DeleteFomMastik from "../Screens/Dashboard/Properties/FomMastik/components/DeleteFomMastik/DeleteFomMastik";
import DeleteKhadamat from "../Screens/Dashboard/Properties/Khadamat/components/DeleteKhadamat/DeleteKhadamat";
import DeleteOlgu from "../Screens/Dashboard/Olgo/DeleteOlgu/DeleteOlgu";
import EditUsers from "Screens/Dashboard/Users/components/EditUsers/EditUsers";
import DeleteColor from "Screens/Dashboard/Properties/Profile/components/TypeColorSetting/components/DeleteColor";
import DeleteSpacer from "../Screens/Dashboard/Properties/Shishe/components/SpacerManage/components/DeleteSpacer";
import DeleteShishe from "Screens/Dashboard/Properties/Shishe/components/ShisheManage/components/DeleteShishe/DeleteShishe";
import DeleteShisheGroupManage from "../Screens/Dashboard/Properties/Shishe/components/ShisheGroupManage/components/DeleteShisheGroupManage";
import EditMahsooleShishe from "Screens/Dashboard/Properties/Shishe/components/EditMahsooleShishe/EditMahsooleShishe";
import IsGFormatter from "Components/Table/ActionFormatter/IsGFormatter";
import { read } from "Helpers/LocalStorage";
import DeleteYaragh from "Screens/Dashboard/Properties/Yaragh/components/DeleteYaragh/DeleteYaragh";
import ProjectCellTitle from "Screens/Dashboard/Projects/components/ProjectsTable/components/ProjectCellTitle";
import IsLockFormatter from "Components/Table/ActionFormatter/IsLockFormatter";
import ProjectCellCustomer from "Screens/Dashboard/Projects/components/ProjectsTable/components/ProjectCellCustomer";
import EditProjectDialog from "Screens/Dashboard/Projects/components/EditProjectDialog/EditProjectDialog";
import DeleteProject from "Screens/Dashboard/Projects/components/DeleteProject/DeleteProject";
import StateProjectDialog from "Screens/Dashboard/Projects/components/StateProjectDialog/StateProjectDialog";
import RequestChangeStatus from "Screens/Dashboard/Projects/components/RequestChangeStatus/RequestChangeStatus";
import ImageBox from "Components/ImageBox/ImageBox";
import SlidingEditDialog from "Screens/Dashboard/Olgo/EditOlguDialog/SlidingEditDialog";
import UserAccess from "Screens/Dashboard/Users/components/UserAccess/UserAccess";
import DeleteUserInfo from "Screens/Dashboard/Users/components/DeleteUser/DeleteUserInfo";
import UserAccessFactor from "../Screens/Dashboard/Users/components/UserAccessFactor/UserAccessFactor";
import CircleColor from "Components/CircleColor/CircleColor";
import DeleteContract from "../Screens/Dashboard/Contract/components/DeleteContract/DeleteContract";
import EditRowContract from "../Screens/Dashboard/Contract/components/EditRowContract/EditRowContract";
import SelectUnitFormatter from "../Screens/Design/components/UnitSideDrawer/components/SelectUnitFormatter";
import ReadFormatter from "../Components/ReadFormatter/ReadFormatter";
import Translator from "../Languages/Utility/Translator";
import MuiButton from "../Components/MuiButton/MuiButton";
import { push } from "../Helpers/History";
import { Checkbox } from "@material-ui/core";
import ActiveFormatter from "../Components/ActiveFormatter/ActiveFormatter";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import Factors from "Screens/Super/Support/components/Factors/Factors";
import Limits from "Screens/Super/Support/components/Limits/Limits";
import Users from "Screens/Super/Support/components/Users/Users";
import Periods from "Screens/Super/Support/components/Periods/Periods";
import Infos from "Screens/Super/Support/components/Infos/Infos";
import PeriodDetails from "Screens/Super/Support/components/Periods/PeriodDetails";
import IncreaseGroupFormatter from "Components/IncreaseGroupFormatter/IncreaseGroupFormatter";
import TypeAddFormatter from "Components/TypeAddFormatter/TypeAddFormatter";
import TypePayFormatter from "Components/TypePayFormatter/TypePayFormatter";
import StatusFormatterIcons from "Components/StatusFormatterIcons/StatusFormatterIcons";
import EditSupervisor from "Screens/Super/Pricing/components/SupervisorUser/EditSupervisor";
import DeleteSupervisor from "Screens/Super/Pricing/components/SupervisorUser/DeleteSupervisor";
import DeletePriceServices from "Screens/Super/Pricing/components/Services/DeletePriceServices";
import EditPriceServices from "Screens/Super/Pricing/components/Services/EditPriceServices";
import EditPriceProducts from "Screens/Super/Pricing/components/Products/EditPriceProducts";
import DeletePriceProducts from "Screens/Super/Pricing/components/Products/DeletePriceProducts";
import EditPriceFactors from "Screens/Super/Pricing/components/Factors/EditPriceFactors";
import DeletePriceFactors from "Screens/Super/Pricing/components/Factors/DeletePriceFactors";
import EditPricePeriods from "Screens/Super/Pricing/components/Periods/EditPricePeriods";
import DeletePricePeriods from "Screens/Super/Pricing/components/Periods/DeletePricePeriods";
import IncTimeGroup from "Screens/Super/Tools/components/IncTime/IncTimeGroup";
import StatusIsFree from "Components/StatusIsFree/StatusIsFree";
import FinancialType from "Components/FinancialType/FinancialType";
import EditDefaultPanel from "Screens/Super/Financial/components/DefaultPanel/EditDefaultPanel";
import DeleteDefaultPanel from "Screens/Super/Financial/components/DefaultPanel/DeleteDefaultPanel";
import EditDefaultCharge from "Screens/Super/Financial/components/DefaultCharges/EditDefaultCharge";
import DeleteDefaultCharge from "Screens/Super/Financial/components/DefaultCharges/DeleteDefaultCharge";
import EditDiscountCard from "Screens/Super/Tools/components/DiscountCard/EditDiscountCard";
import DeleteDiscountCard from "Screens/Super/Tools/components/DiscountCard/DeleteDiscountCard";
import UsedGroup from "Screens/Super/Tools/components/DiscountCard/UsedGroup";
import EditShisheGroupManage from "Screens/Dashboard/Properties/Shishe/components/ShisheGroupManage/components/EditShisheGroupManage";
import EditShishe from "Screens/Dashboard/Properties/Shishe/components/ShisheManage/components/EditShishe";
import EditSpacer from "Screens/Dashboard/Properties/Shishe/components/SpacerManage/components/EditSpacer";
import ShowTicket from "Screens/Super/Tickets/components/ShowTicket";
import TicketStatusFormatter from "Components/TicketStatusFormatter/TicketStatusFormatter";
import NameFormatter from "Components/ConstructionFormatter/NameFormatter";
import UnitDetailsFormatter from "Components/ConstructionFormatter/UnitDetailsFormatter";
import MahdoodeFaniRowEditor from "Screens/Dashboard/Properties/Yaragh/components/MahdoodeFani/components/MahdoodeFaniRowEditor";
import MahdoodeFaniDeleteRow from "Screens/Dashboard/Properties/Yaragh/components/MahdoodeFani/components/MahdoodeFaniDeleteRow";
import DeleteStuff from "Screens/Dashboard/Properties/Yaragh/components/MahdoodeFani/components/StuffFitting/components/Delete/DeleteStuff";
import EditStuff from "Screens/Dashboard/Properties/Yaragh/components/MahdoodeFani/components/StuffFitting/components/Edit/EditStuff";
import ProductList from "Screens/Dashboard/Properties/Yaragh/components/MahdoodeFani/components/ProductList/ProductList";
import * as Icons from "react-bootstrap-icons";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import ManageNotification from "Screens/Dashboard/Notifications/components/ManageNotification";
import CheckTableValidation from "Helpers/CheckTableValidation";
import PriceWithUnitShow from "Helpers/PriceWithUnitShow";
import NoticeDetails from "Screens/Super/Notice/components/NoticeDetails";
import NoticeReader from "Screens/Super/Notice/components/NoticeReader";
import NoticeDelete from "Screens/Super/Notice/components/NoticeDelete";
import EditPatternGroup from "Screens/Dashboard/Settings/ShopSettings/components/PatternGroup/Edit";
import DeletePatternGroup from "Screens/Dashboard/Settings/ShopSettings/components/PatternGroup/Delete";
import TemplateIndex from "Screens/Dashboard/Settings/ShopSettings/components/PatternGroup/Template/TemplateIndex";
import EditGlass from "Screens/Dashboard/Settings/ShopSettings/components/Glass/Edit";
import DeleteGlass from "Screens/Dashboard/Settings/ShopSettings/components/Glass/Delete";
import DeleteProjects from "Screens/Dashboard/Settings/ShopSettings/components/Projects/Delete";
import EditProjects from "Screens/Dashboard/Settings/ShopSettings/components/Projects/Edit";
import ProjectUnitInfo from "Screens/Dashboard/Settings/ShopSettings/components/Projects/SelectedProject/UnitInfo";
import ProjectUnitDetails from "Screens/Dashboard/Settings/ShopSettings/components/Projects/SelectedProject/UnitDetails";

export const projectsColumn = [
  {
    dataField: "IsLock",
    text: "",
    formatter: (cell) => <IsLockFormatter cell={cell} />,
    align: "center",
    headerAlign: "center",
    classes: "normal",
    headerClasses: "Lock",
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="projectName" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell, row) => <ProjectCellTitle cell={cell} row={row} />,
  },
  {
    dataField: "NameCustomer",
    text: <Translator id="customer" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell, row) => <ProjectCellCustomer cell={cell} row={row} />,
  },
  {
    dataField: "DateRegister",
    text: <Translator id="date" noSpan />,
    align: "center",
    headerAlign: "center",
    headerClasses: "date-show",
  },
  {
    dataField: "NameState",
    text: <Translator id="status" noSpan />,
    align: "center",
    headerAlign: "center",
    headerClasses: "prj-status",
    formatter: (cell, row) => <StateProjectDialog row={row} />,
  },
  {
    dataField: "request",
    text: "",
    formatter: (cell, row) => <RequestChangeStatus row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
  },
  // {
  //   dataField: "ProjectRedirects_design",
  //   text: "",
  //   formatter: (cell, row) => <ProjectRedirects cell={cell} row={row} title={'design'} icon={DesignIcon} path={'/dashboard/projects/design'} />,
  //   align: "center",
  //   headerClasses: "project-btn",
  //   editable: false,
  // },
  // {
  //   dataField: "ProjectRedirects_invoices",
  //   text: "",
  //   formatter: (cell, row) => <ProjectRedirects cell={cell} row={row} title={'invoices'} icon={InvoicesIcon} path={'/dashboard/projects/invoices'} />,
  //   align: "center",
  //   headerClasses: "project-btn",
  //   editable: false,
  // },
  // {
  //   dataField: "ProjectRedirects_contract",
  //   text: "",
  //   formatter: (cell, row) => <ProjectRedirects cell={cell} row={row} title={'contract'} icon={ContractIcon} path={'/dashboard/projects/contract'} />,
  //   align: "center",
  //   headerClasses: "project-btn",
  //   editable: false,
  // },
  // {
  //   dataField: "ProjectRedirects_construction",
  //   text: "",
  //   formatter: (cell, row) => <ProjectRedirects cell={cell} row={row} title={'construction'} icon={ConstructionIcon} path={'/dashboard/projects/construction'} />,
  //   align: "center",
  //   headerClasses: "project-btn",
  //   editable: false,
  // },
  // {
  //   dataField: "ProjectRedirects_profit",
  //   text: "",
  //   formatter: (cell, row) => <ProjectRedirects cell={cell} row={row} title={'profit'} icon={ProfitIcon} path={'/dashboard/projects/profit'} />,
  //   align: "center",
  //   headerClasses: "project-btn",
  //   editable: false,
  // },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <EditProjectDialog row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeleteProject row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const customerColumn = [
  {
    dataField: "num",
    text: "",
    align: "right",
    headerAlign: "right",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "Name",
    text: <Translator id="name" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "NameCity",
    text: <Translator id="city" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "NameGroup",
    text: <Translator id="NameGroup" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "Mobile",
    text: <Translator id="mobile" noSpan />,
    align: "right",
    headerAlign: "right",
    classes: "phoneCol",
  },
  {
    dataField: "Tell",
    text: <Translator id="telephone" noSpan />,
    align: "right",
    headerAlign: "right",
    classes: "phoneCol",
  },
  {
    dataField: "Fax",
    text: <Translator id="fax" noSpan />,
    align: "right",
    headerAlign: "right",
    classes: "phoneCol",
  },
  {
    dataField: "Address",
    text: <Translator id="address" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <EditCustomer row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeleteCustomer row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const userColumn = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "DisplayName",
    text: <Translator id="fullName" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "UserName",
    text: <Translator id="userName" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  // {
  //   dataField: "NameStype",
  //   text: => naghsh,
  //   align: "right",
  //   headerAlign: "right",
  //   editable: false,
  // },
  // {
  //   dataField: "NameStypePanel",
  //   text: => type,
  //   align: "right",
  //   headerAlign: "right",
  //   editable: false,
  // },

  // {
  //   dataField: "Email",
  //   text: => email,
  //   align: "right",
  //   headerAlign: "right",
  //   editable: false,
  // },
  {
    dataField: "PhoneNumber",
    text: <Translator id="phone" noSpan />,
    align: "center",
    classes: "phoneCol",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "NameGroupPrice",
    text: <Translator id="financial_group" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "Active",
    text: <Translator id="status" noSpan />,
    formatter: (cell) => StatusFormatter(cell),
    align: "center",
    headerAlign: "center",
    editor: {
      type: Type.CHECKBOX,
      value: "true:false",
    },
    headerClasses: "status",
  },
  {
    dataField: "access",
    text: "",
    formatter: (cell, row) => <UserAccessFactor row={row} />,
    align: "center",
    headerClasses: "action",
    classes: "normal",
    editable: false,
  },
  {
    dataField: "access",
    text: "",
    formatter: (cell, row) => <UserAccess row={row} />,
    align: "center",
    headerClasses: "action",
    classes: "normal",
    editable: false,
  },

  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <EditUsers row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },

  {
    dataField: "deleteInfo",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeleteUserInfo row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  // {
  //   dataField: "delete",
  //   text: "",
  //   isDummyField: true,
  //   formatter: (cell, row) => <DeleteUser row={row} />,
  //   align: "right",
  //   classes: "normal",
  //   headerClasses: "action",
  //   editable: false,
  // },
];

export const profileColumn = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "Name",
    text: <Translator id="name" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
    headerStyle: { width: "50%" },
  },
  {
    dataField: "Size",
    text: <Translator id="size" noSpan />,
    align: "right",
    headerStyle: { width: "10%" },
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "Weight",
    text: <Translator id="weight" noSpan />,
    align: "center",
    headerAlign: "center",
    hidden: true,
    sort: true,
    headerStyle: { width: "10%" },
    editorClasses: "inputEditor",
    inputType: "number",
    validator: (newValue) =>
      CheckTableValidation(newValue, { number: true, decimal: true }),
    editable: () =>
      read("StypeU") === "1" ||
      (read("StypeU") === "1" && read("addSeriProfileRules").accessUpdate),
  },
  {
    dataField: "GroupPrice",
    text: <PriceWithUnitShow id="groupPrice" />,
    align: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    headerAlign: "center",
    validator: (newValue) => CheckTableValidation(newValue, { price: true }),
    editable: (content, row) => read("StypeU") === "1" && !row.Disable,
  },
  {
    dataField: "UserPrice",
    text: <PriceWithUnitShow id="userPrice" />,
    align: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    headerAlign: "center",
    validator: (newValue) => CheckTableValidation(newValue, { price: true }),
  },
];

export const profileSeriesColumn = [
  {
    dataField: "IdCountry",
    text: <Translator id="keshvar" noSpan />,
    align: "right",
    headerStyle: { width: "15%" },
    headerAlign: "right",
    headerClasses: "typeClass",
    formatter: CountryFormatter,
  },
  {
    dataField: "Type",
    text: <Translator id="type" noSpan />,
    headerStyle: { width: "15%" },
    align: "right",
    headerAlign: "right",
    headerClasses: "typeClass",
    formatter: TagFormatter,
  },
  {
    dataField: "Struct",
    text: <Translator id="struct" noSpan />,
    align: "right",
    headerStyle: { width: "15%" },
    headerAlign: "right",
    headerClasses: "materialClass",
    formatter: TagFormatter,
  },
  {
    dataField: "NameBrand",
    text: <Translator id="brandName" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "Name",
    text: <Translator id="name" noSpan />,
    align: "right",
    headerAlign: "right",
  },
];

export const colorsColumn = [
  {
    dataField: "IsG",
    text: "",
    formatter: (cell) => <IsGFormatter cell={cell} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "NameColor",
    text: <Translator id="name" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    inputType: "text",
    editable: true,
  },
  {
    dataField: "ColorPattern",
    text: <Translator id="color" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell) => (
      <CircleColor
        background={cell.Value}
        size="large"
        className="circle-color-palette"
        title={cell.Name}
      />
    ),
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeleteColor row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const mahdoodeColumn = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "IsG",
    text: "",
    formatter: (cell) => <IsGFormatter cell={cell} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="name" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "mahdodeArz",
    text: <Translator id="widthRange" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
    classes: "normal",
  },
  {
    dataField: "mahdodeErtefa",
    text: <Translator id="heightRange" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
    classes: "normal",
  },
  {
    dataField: "GroupPrice",
    text: <PriceWithUnitShow id="groupPrice" />,
    align: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    headerAlign: "center",
    validator: (newValue) => CheckTableValidation(newValue, { price: true }),
    editable: (content, row) => read("StypeU") === "1" && !row.Disable,
  },
  {
    dataField: "UserPrice",
    text: <PriceWithUnitShow id="userPrice" />,
    align: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    headerAlign: "center",
    validator: (newValue) => CheckTableValidation(newValue, { price: true }),
    editable: (content, row) =>
      (!row.IsG &&
        read("StypeU") !== "1" &&
        !row.Disable &&
        read("yaraghRules").accessUpdate) ||
      (row.IsG &&
        read("StypeU") !== "1" &&
        !row.Disable &&
        read("yaraghRules").accessPrice2),
  },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <MahdoodeRowEditor row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeleteYaragh row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const mahdoodeFaniColumn = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "IsG",
    text: "",
    formatter: (cell) => <IsGFormatter cell={cell} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "Code",
    text: <Translator id="name" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "width",
    text: <Translator id="widthRange" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
    classes: "normal",
  },
  {
    dataField: "height",
    text: <Translator id="heightRange" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
    classes: "normal",
  },
  {
    dataField: "productList",
    text: "",
    formatter: (cell, row) => <ProductList key={row.id} prow={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <MahdoodeFaniRowEditor row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <MahdoodeFaniDeleteRow row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const partLocalList = [
  {
    dataField: "num",
    text: "",
    align: "right",
    headerAlign: "right",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "StuffFitting",
    text: <Translator id="name" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "StuffFittingCode",
    text: <Translator id="standardCode" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
    classes: "normal",
  },
  {
    dataField: "Count",
    text: <Translator id="partCount" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
    classes: "normal",
  },
];

export const stuffList = [
  {
    dataField: "num",
    text: "",
    align: "right",
    headerAlign: "right",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "Name",
    text: <Translator id="name" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "Code",
    text: <Translator id="standardCode" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
    classes: "normal",
  },
  {
    dataField: "Ax",
    text: <Translator id="stuffAx" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
    classes: "normal",
  },
  {
    dataField: "Sdirection",
    text: <Translator id="stuffSide" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
    classes: "normal",
  },
  {
    dataField: "ColorFitting",
    text: <Translator id="stuffColor" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
    classes: "normal",
  },
  {
    dataField: "SlevelSecurity",
    text: <Translator id="stuffLevelSecurity" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
    classes: "normal",
  },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <EditStuff row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeleteStuff row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const mahdoodeFaniCopy = [
  {
    dataField: "num",
    text: "",
    align: "right",
    headerAlign: "right",
    editable: false,
    headerStyle: { width: "20%" },
  },
  {
    dataField: "Code",
    text: <Translator id="name" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
];

export const brandColumn = [
  {
    dataField: "IdCountry",
    text: <Translator id="keshvar" noSpan />,
    align: "center",
    headerAlign: "center",
    headerClasses: "typeClass",
    formatter: CountryFormatter,
  },
  {
    dataField: "Struct",
    text: <Translator id="struct" noSpan />,
    align: "center",
    headerAlign: "center",
    headerClasses: "materialClass",
    formatter: TagFormatter,
  },
  {
    dataField: "Name",
    text: <Translator id="brandName" noSpan />,
    align: "center",
    headerAlign: "center",
  },
];

export const rokubColumn = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "IsG",
    text: "",
    formatter: (cell) => <IsGFormatter cell={cell} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="name" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "Size",
    text: <Translator id="sizeMM" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "NameStruct",
    text: <Translator id="struct" noSpan />,
    align: "center",
    headerAlign: "center",
    headerClasses: "materialClass",
    formatter: TagFormatter,
    editable: false,
  },
  {
    dataField: "GroupPrice",
    text: <PriceWithUnitShow id="groupPrice" />,
    align: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    headerAlign: "center",
    validator: (newValue) => CheckTableValidation(newValue, { price: true }),
    editable: (content, row) => read("StypeU") === "1" && !row.Disable,
  },
  {
    dataField: "UserPrice",
    text: <PriceWithUnitShow id="userPrice" />,
    align: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    headerAlign: "center",
    validator: (newValue) => CheckTableValidation(newValue, { price: true }),
    editable: (content, row) =>
      (!row.IsG &&
        read("StypeU") !== "1" &&
        !row.Disable &&
        read("rokubRules").accessUpdate) ||
      (row.IsG &&
        read("StypeU") !== "1" &&
        !row.Disable &&
        read("rokubRules").accessPrice2),
  },
  {
    dataField: "Disable",
    text: <Translator id="status" noSpan />,
    formatter: TagFormatter,
    align: "right",
    headerAlign: "right",
    editor: {
      type: Type.CHECKBOX,
      value: "false:true",
    },
    headerClasses: "status",
    editable: (content, row) =>
      (!row.IsG && read("StypeU") !== "1") ||
      (row.IsG && read("StypeU") === "1"),
  },

  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <RokubRowEditor row={row} />,
    align: "right",
    editable: false,
    headerClasses: "action",
    classes: "normal",
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeleteRokub row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const fomMastikColumn = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "IsG",
    text: "",
    formatter: (cell) => <IsGFormatter cell={cell} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="name" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "NameType",
    text: <Translator id="type" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },

  {
    dataField: "Cover",
    text: <Translator id="coverage" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "GroupPrice",
    text: <PriceWithUnitShow id="groupPrice" />,
    align: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    headerAlign: "center",
    validator: (newValue) => CheckTableValidation(newValue, { price: true }),
    editable: (content, row) => read("StypeU") === "1" && !row.Disable,
  },
  {
    dataField: "UserPrice",
    text: <PriceWithUnitShow id="userPrice" />,
    align: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    headerAlign: "center",
    validator: (newValue) => CheckTableValidation(newValue, { price: true }),
    editable: (content, row) =>
      (!row.IsG &&
        read("StypeU") !== "1" &&
        !row.Disable &&
        read("fomMasticRules").accessUpdate) ||
      (row.IsG &&
        read("StypeU") !== "1" &&
        !row.Disable &&
        read("fomMasticRules").accessPrice2),
  },
  {
    dataField: "Disable",
    text: <Translator id="status" noSpan />,
    formatter: TagFormatter,
    align: "right",
    headerAlign: "right",
    editor: {
      type: Type.CHECKBOX,
      value: "false:true",
    },
    headerClasses: "status",
    editable: (content, row) =>
      (!row.IsG && read("StypeU") !== "1") ||
      (row.IsG && read("StypeU") === "1"),
  },

  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <FomMastikRowEditor row={row} />,
    align: "right",
    editable: false,
    headerClasses: "action",
    classes: "normal",
  },
  {
    dataField: "delete",
    text: "",
    formatter: (cell, row) => <DeleteFomMastik row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const toriColumn = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "IsG",
    text: "",
    formatter: (cell) => <IsGFormatter cell={cell} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="name" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "IncW",
    text: <Translator id="width" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "IncH",
    text: <Translator id="height" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "MovableInc",
    text: <Translator id="MovableInc" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "MovableCount",
    text: <Translator id="MovableCount" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "GroupPrice",
    text: <PriceWithUnitShow id="groupPrice" />,
    align: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    headerAlign: "center",
    validator: (newValue) => CheckTableValidation(newValue, { price: true }),
    editable: (content, row) => read("StypeU") === "1" && !row.Disable,
  },
  {
    dataField: "UserPrice",
    text: <PriceWithUnitShow id="userPrice" />,
    align: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    headerAlign: "center",
    validator: (newValue) => CheckTableValidation(newValue, { price: true }),
    editable: (content, row) =>
      (!row.IsG &&
        read("StypeU") !== "1" &&
        !row.Disable &&
        read("toriRules").accessUpdate) ||
      (row.IsG &&
        read("StypeU") !== "1" &&
        !row.Disable &&
        read("toriRules").accessPrice2),
  },
  {
    dataField: "Disable",
    text: <Translator id="status" noSpan />,
    formatter: TagFormatter,
    align: "right",
    headerAlign: "right",
    headerClasses: "status",
    editor: {
      type: Type.CHECKBOX,
      value: "false:true",
    },
    editable: (content, row) =>
      (!row.IsG && read("StypeU") !== "1") ||
      (row.IsG && read("StypeU") === "1"),
  },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <EditTori cell={cell} row={row} />,
    align: "right",
    editable: false,
    headerClasses: "action",
    classes: "normal",
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeleteTori cell={cell} row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const khedmatColumn = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "IsG",
    text: "",
    formatter: (cell) => <IsGFormatter cell={cell} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="title" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "NameSys",
    text: <Translator id="method" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },

  {
    dataField: "GroupPrice",
    text: <PriceWithUnitShow id="groupPrice" />,
    align: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    headerAlign: "center",
    validator: (newValue) => CheckTableValidation(newValue, { price: true }),
    editable: (content, row) => read("StypeU") === "1" && !row.Disable,
  },
  {
    dataField: "UserPrice",
    text: <PriceWithUnitShow id="userPrice" />,
    align: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    headerAlign: "center",
    validator: (newValue) => CheckTableValidation(newValue, { price: true }),
    editable: (content, row) =>
      (!row.IsG &&
        read("StypeU") !== "1" &&
        !row.Disable &&
        read("khadamatRules").accessUpdate) ||
      (row.IsG &&
        read("StypeU") !== "1" &&
        !row.Disable &&
        read("khadamatRules").accessPrice2),
  },
  {
    dataField: "Disable",
    text: <Translator id="status" noSpan />,
    formatter: TagFormatter,
    align: "right",
    headerAlign: "right",
    headerClasses: "status",
    editor: {
      type: Type.CHECKBOX,
      value: "false:true",
    },
    editable: (content, row) =>
      (!row.IsG && read("StypeU") !== "1") ||
      (row.IsG && read("StypeU") === "1"),
  },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <EditRowKhedmat cell={cell} row={row} />,
    align: "right",
    editable: false,
    headerClasses: "action",
    classes: "normal",
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeleteKhadamat cell={cell} row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const spacersColumn = [
  {
    dataField: "IsG",
    text: "",
    formatter: (cell) => <IsGFormatter cell={cell} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="spacerName" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    inputType: "text",
    editable: false,
  },
  {
    dataField: "Thick",
    text: <Translator id="thickness" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    editable: false,
  },
  {
    dataField: "Price",
    text: <Translator id="price" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    editable: false,
  },
  {
    dataField: "Disable",
    text: <Translator id="status" noSpan />,
    formatter: TagFormatter,
    align: "right",
    headerAlign: "right",
    editor: {
      type: Type.CHECKBOX,
      value: "false:true",
    },
    editable: (content, row) =>
      (!row.IsG && read("StypeU") !== "1") ||
      (row.IsG && read("StypeU") === "1"),
  },
  {
    dataField: "edit",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <EditSpacer row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeleteSpacer row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const shisheColumn = [
  {
    dataField: "IsG",
    text: "",
    formatter: (cell) => <IsGFormatter cell={cell} />,
    align: "center",
    headerAlign: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="nameshishe" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    inputType: "text",
    editable: false,
  },
  {
    dataField: "Thick",
    text: <Translator id="thickness" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    editable: false,
  },
  {
    dataField: "Price",
    text: <Translator id="price" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    editable: false,
  },
  {
    dataField: "Disable",
    text: <Translator id="status" noSpan />,
    formatter: TagFormatter,
    align: "right",
    headerAlign: "right",
    editor: {
      type: Type.CHECKBOX,
      value: "false:true",
    },
    editable: (content, row) =>
      (!row.IsG && read("StypeU") !== "1") ||
      (row.IsG && read("StypeU") === "1"),
  },
  {
    dataField: "edit",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <EditShishe row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeleteShishe row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const shisheGroupColumn = [
  {
    dataField: "IsG",
    text: "",
    formatter: (cell) => <IsGFormatter cell={cell} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="shisheGroupName" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    inputType: "text",
    editable: false,
    // editable: (content, row) =>
    //   (row.IsG && read("StypeU") === "1" && !row.Disable) ||
    //   (!row.IsG &&
    //     read("StypeU") !== "1" &&
    //     !row.Disable &&
    //     read("mahsoleShisheGroupRules").accessUpdate),
  },
  {
    dataField: "Disable",
    text: <Translator id="status" noSpan />,
    formatter: TagFormatter,
    align: "right",
    headerAlign: "right",
    editor: {
      type: Type.CHECKBOX,
      value: "false:true",
    },
    editable: (content, row) =>
      (!row.IsG && read("StypeU") !== "1") ||
      (row.IsG && read("StypeU") === "1"),
  },
  {
    dataField: "edit",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <EditShisheGroupManage row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeleteShisheGroupManage row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const mahsooleShisheColumn = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "IsG",
    text: "",
    formatter: (cell) => <IsGFormatter cell={cell} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="nameshishe" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "NameGroup",
    text: <Translator id="shisheGroupName" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },

  {
    dataField: "Wall",
    text: <Translator id="jedare" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "ThickCalc",
    text: <Translator id="thickness" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "GroupPrice",
    text: <PriceWithUnitShow id="groupPrice" />,
    align: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    headerAlign: "center",
    validator: (newValue) => CheckTableValidation(newValue, { price: true }),
    editable: (content, row) => read("StypeU") === "1" && !row.Disable,
  },
  {
    dataField: "UserPrice",
    text: <PriceWithUnitShow id="userPrice" />,
    align: "center",
    editorClasses: "inputEditor",
    inputType: "number",
    headerAlign: "center",
    validator: (newValue) => CheckTableValidation(newValue, { price: true }),
    editable: (content, row) =>
      (!row.IsG &&
        read("StypeU") !== "1" &&
        !row.Disable &&
        read("mahsoleShisheRules").accessUpdate) ||
      (row.IsG &&
        read("StypeU") !== "1" &&
        !row.Disable &&
        read("mahsoleShisheRules").accessPrice2),
  },
  {
    dataField: "Disable",
    text: <Translator id="status" noSpan />,
    formatter: TagFormatter,
    align: "right",
    headerAlign: "right",
    editor: {
      type: Type.CHECKBOX,
      value: "false:true",
    },
    headerClasses: "status",
    editable: (content, row) =>
      (!row.IsG && read("StypeU") !== "1") ||
      (row.IsG && read("StypeU") === "1"),
  },
  {
    dataField: "ColorPattern",
    text: <Translator id="color" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell) => (
      <CircleColor
        background={cell.Value}
        size="large"
        className="m-auto"
        title={cell.Name}
      />
    ),
    editable: false,
  },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <EditMahsooleShishe row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeleteMahsooleShishe row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const olguColumn = [
  {
    dataField: "num",
    text: "",
    align: "right",
    headerAlign: "right",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "IsG",
    text: "",
    formatter: (cell) => <IsGFormatter cell={cell} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="name" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "Color",
    text: <Translator id="color" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "Frame",
    text: <Translator id="frame" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "Fitting",
    text: <Translator id="fitting" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "Glass",
    text: <Translator id="glass" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "Net",
    text: <Translator id="net" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "Disable",
    text: <Translator id="status" noSpan />,
    formatter: TagFormatter,
    align: "right",
    headerAlign: "right",
    editor: {
      type: Type.CHECKBOX,
      value: "false:true",
    },
    editable: (content, row) =>
      (!row.IsG && read("StypeU") !== "1") ||
      (row.IsG && read("StypeU") === "1"),
  },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => {
      if (row.Type === 1) {
        return <HingedEditDialog cell={cell} row={row} />;
      } else if (row.Type === 2) {
        return <SlidingEditDialog cell={cell} row={row} />;
      }
    },
    align: "right",
    headerClasses: "action",
    classes: "normal",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeleteOlgu row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const designOlguColumn = [
  {
    dataField: "IsG",
    text: "",
    formatter: (cell) => <IsGFormatter cell={cell} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="name" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "Color",
    text: <Translator id="color" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "Frame",
    text: <Translator id="frame" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "Fitting",
    text: <Translator id="yaragh" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "Glass",
    text: <Translator id="shishe" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "Net",
    text: <Translator id="tori" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
];

export const designOlguColumnFastMode = [
  {
    dataField: "IsG",
    text: "",
    formatter: (cell) => <IsGFormatter cell={cell} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="name" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "Frame",
    text: <Translator id="frame" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
];

export const constructionColumn = [
  {
    dataField: "Image",
    text: <Translator id="Image" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell) => <ImageBox image={`data:image/png;base64, ${cell}`} />,
    headerClasses: "image",
  },
  {
    dataField: "Name",
    text: <Translator id="nameUnit" noSpan />,
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "15%" },
    formatter: (cell, row) => <NameFormatter row={row} cell={cell} />,
  },
  {
    dataField: "HUnit",
    text: <Translator id="sizeV2" noSpan />,
    align: "center",
    headerAlign: "center",
    classes: "number",
    formatter: (cell, row) => (
      <span className="normalTitle">{`${row.WUnit} x  ${cell}`}</span>
    ),
    headerStyle: { width: "15%" },
  },
  // {
  //   dataField: "CountUnit",
  //   text: <Translator id="count" noSpan />,
  //   align: "center",
  //   headerAlign: "center",
  //   headerStyle: { width: "8%" },
  // },
  // {
  //   dataField: "Struct",
  //   text: <Translator id='Structure' noSpan />,
  //   align: "center",
  //   headerAlign: "center",
  //   formatter: TagFormatter,
  //   headerClasses: "tag",
  //   headerStyle: { width: "8%" },
  // },
  // {
  //   dataField: "NameProject",
  //   text: <Translator id="projectName" noSpan/>,
  //   align: "center",
  //   headerAlign: "center",
  //   headerStyle: { width: "10%" },
  //   formatter: cell => <span>{cell}</span>,
  // },
  {
    dataField: "GroupProfile",
    text: <Translator id="unitDetails" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell, row) => <UnitDetailsFormatter row={row} cell={cell} />,
  },
  // {
  //   dataField: "GroupProfile",
  //   text: <Translator id='profiles' noSpan />,
  //   align: "center",
  //   headerAlign: "center",
  // },
  // {
  //   dataField: "Fitting",
  //   text: <Translator id='fittings' noSpan />,
  //   align: "center",
  //   headerAlign: "center",
  // },
  // {
  //   dataField: "Glass",
  //   text: <Translator id='glasses' noSpan />,
  //   align: "center",
  //   headerAlign: "center",
  // },
];

export const factorColumn = [
  {
    dataField: "Image",
    text: <Translator id="Image" noSpan />,
    align: "right",
    headerAlign: "right",
    formatter: (cell) => <ImageBox image={`data:image/png;base64, ${cell}`} />,
    headerClasses: "image",
  },
  {
    dataField: "Name",
    text: <Translator id="nameUnit" noSpan />,
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "15%" },
    formatter: (cell, row) => <NameFormatter row={row} cell={cell} />,
  },
  {
    dataField: "HUnit",
    text: <Translator id="sizeV2" noSpan />,
    align: "right",
    headerAlign: "right",
    classes: "number",
    formatter: (cell, row) => (
      <span className="normalTitle">{`${row.WUnit} x  ${cell}`}</span>
    ),
    headerStyle: { width: "15%" },
  },
  {
    dataField: "TypeUnit",
    text: <Translator id="Structure" noSpan />,
    align: "right",
    headerAlign: "right",
    formatter: TagFormatter,
    headerClasses: "tag",
  },
  {
    dataField: "Location",
    text: <Translator id="placeLocation" noSpan />,
    align: "right",
    headerAlign: "right",
    formatter: (cell) => <p>{cell ? cell : "---"}</p>,
  },
  // {
  //   dataField: "CountUnit",
  //   text: <Translator id="count" noSpan />,
  //   align: "right",
  //   headerAlign: "right",
  // },

  // {
  //   dataField: "GroupProfile",
  //   text: <Translator id='unitDetails' noSpan />,
  //   align: "right",
  //   headerAlign: "right",
  //   formatter: (cell, row) => <UnitDetailsFormatter row={row} cell={cell} />,
  // },
];

export const viewDetailsColumn = [
  {
    dataField: "Row",
    text: "",
    align: "center",
    headerAlign: "center",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "Description",
    text: <Translator id="description" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Value",
    text: <Translator id="count" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "PriceUnit",
    text: (
      <span>
        <Translator id="unitPrice" noSpan /> (
        <Translator id="moneyUnit" noSpan />)
      </span>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "Price",
    text: (
      <span>
        <Translator id="price" noSpan /> (<Translator id="moneyUnit" noSpan />)
      </span>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
];

export const contractColumn = [
  {
    dataField: "Type",
    text: <Translator id="paymentType2" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "Price",
    text: <Translator id="amountPaid" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "Bank",
    text: <Translator id="bank" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "Branch",
    text: <Translator id="branch" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "ShoDocument",
    text: <Translator id="paymentDocument" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "Date",
    text: <Translator id="date" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "Description",
    text: <Translator id="description" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <EditRowContract row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeleteContract row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const unitListColumn = [
  {
    dataField: "Name",
    text: <Translator id="ـnameUnit" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "HUnit",
    text: <Translator id="size" noSpan />,
    align: "right",
    headerAlign: "right",
    classes: "number",
    formatter: (cell, row) => (
      <div className="text-nowrap">{`${row.WUnit} x ${row.HUnit}`}</div>
    ),
  },
  /*{
    dataField: "HUnit",
    text: => size,
    align: "right",
    headerAlign: "right",
    classes: "number",
    formatter: (cell, row) => <div>{`${row.WUnit} x  ${cell}`}</div>,
  },
  {
    dataField: "Location",
    text: => install place,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "CountUnit",
    text: => count,
    align: "right",
    headerAlign: "right",
  },*/
  {
    dataField: "TypeUnit",
    text: <Translator id="selectType" noSpan />,
    align: "right",
    headerAlign: "right",
    formatter: TagFormatter,
    headerClasses: "tag",
  },
  // {
  //   dataField: "edit",
  //   text: <Translator id='editUnit' noSpan />,
  //   formatter: (cell, row) => <EditUnitInner row={row} />,
  //   align: "right",
  //   headerAlign: "right",
  //   classes: "normal",
  //   editable: false,
  // },
  {
    dataField: "IsSelect",
    text: <Translator id="select" noSpan />,
    align: "right",
    headerAlign: "right",
    headerClasses: "status",
    formatter: (cell, row) => <SelectUnitFormatter row={row} cell={cell} />,
  },
];

export const notificationsColumn = [
  {
    dataField: "Row",
    text: "",
    align: "center",
    headerAlign: "center",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "DateRegister",
    text: <Translator id="date" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
    // headerClasses: "date-show",
  },
  {
    dataField: "GroupNotice",
    text: <Translator id="group" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "Title",
    text: <Translator id="description" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "isRead",
    text: <Translator id="status" noSpan />,
    formatter: (sell, row) => <ReadFormatter row={row} />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "manage",
    text: "",
    formatter: (cell, row) => <ManageNotification row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
  },
];

export const ticketColumn = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "DateRegister",
    text: <Translator id="date" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell) => {
      return <>{cell.split("-")[0]}</>;
    },
  },
  {
    dataField: "Title",
    text: <Translator id="title" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "GroupTicket",
    text: <Translator id="ticketSubset" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Status",
    text: <Translator id="status" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell, row) => <TicketStatusFormatter cell={cell} row={row} />,
  },
  {
    dataField: "action",
    text: <Translator id="ticketDetails" noSpan />,
    headerAlign: "center",
    isDummyField: true,
    formatter: (cell, row) => (
      <MuiIconButton
        className="warning-fill"
        onClick={() => push("/dashboard/support/tickets/" + row.Id)}
        icon={<Icons.CardList size={20} />}
        title={<Translator id="display" />}
      />
    ),
    align: "center",
    classes: "normal",
    headerClasses: "actionBtn",
    editable: false,
  },
];

export const historyColumn = [
  {
    dataField: "Period",
    text: <Translator id="periodName" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "FromJalali",
    text: <Translator id="fromDate" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "ToJalali",
    text: <Translator id="toDate" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Price",
    text: <Translator id="price" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "Active",
    text: <Translator id="status" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (sell, row) => <ActiveFormatter row={row} />,
  },

  {
    dataField: "action",
    text: <Translator id="peroidDetails" noSpan />,
    align: "center",
    headerAlign: "center",
    isDummyField: true,
    formatter: (cell, row) => (
      <MuiButton
        className="link"
        onClick={() => push("/dashboard/payment/histories/" + row.Id)}
        title={<Translator id="display" />}
      />
    ),
    classes: "normal",
    // headerClasses: "actionBtn",
    editable: false,
  },
];

export const historyDetailsItemsColumn = [
  {
    dataField: "Row",
    text: "",
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "JalaliDate",
    text: <Translator id="date" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  // {
  //   dataField: "TypeAddId",
  //   text: <Translator id="type" noSpan />,
  //   formatter: (cell) => TypeAddFormatter(cell, false),
  //   align: "center",
  //   headerAlign: "center",
  // },
  {
    dataField: "TypeAdd",
    text: <Translator id="type" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Group",
    text: <Translator id="group" noSpan />,
    formatter: (cell) => IncreaseGroupFormatter(cell, false),
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Description",
    text: <Translator id="description" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Value",
    text: <Translator id="count" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "PriceUnit",
    text: (
      <span>
        <Translator id="unitPrice" noSpan /> (
        <Translator id="moneyUnit" noSpan />)
      </span>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "Price",
    text: (
      <span>
        <Translator id="price" noSpan /> (<Translator id="moneyUnit" noSpan />)
      </span>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
];

export const historyDetailsPaymentsColumn = [
  {
    dataField: "Row",
    text: "",
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "JalaliDate",
    text: <Translator id="date" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Type",
    text: <Translator id="sapd_payType" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Description",
    text: <Translator id="description" noSpan />,
    align: "center",
    headerAlign: "center",
    classes: "number",
  },
  {
    dataField: "Price",
    text: (
      <span>
        <Translator id="price" noSpan /> (<Translator id="moneyUnit" noSpan />)
      </span>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
];

export const benefitColumn = [
  {
    dataField: "Date",
    text: <Translator id="date" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "Sho",
    text: <Translator id="invoice_number" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "CountUnits",
    text: <Translator id="numberUnit" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "AreaUnits",
    text: <Translator id="unit_space" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "PriceFactor",
    text: <Translator id="price_factor" noSpan />,
    align: "right",
    headerAlign: "right",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "PriceAdmin",
    text: <Translator id="admin_price" noSpan />,
    align: "right",
    headerAlign: "right",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "PriceGroup",
    text: <Translator id="financial_group_price" noSpan />,
    align: "right",
    headerAlign: "right",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "PriceUser",
    text: <Translator id="user_price" noSpan />,
    align: "right",
    headerAlign: "right",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "IsContract",
    text: <Translator id="contracted" noSpan />,
    align: "right",
    headerAlign: "right",
    formatter: (cell) => {
      return (
        <Checkbox
          className="selectRadio"
          color="default"
          // size="small"
          checked={cell}
          // checkedIcon={<ReactSVG src={checkBoxCheckedIcon} />}
          // icon={<ReactSVG src={checkBoxIcon} />}
        />
      );
    },
  },
  {
    dataField: "action",
    text: "",
    align: "right",
    headerAlign: "right",
    // headerStyle: { width: "7%" },
    isDummyField: true,
    formatter: (cell, row) => (
      <MuiButton
        // className="link"
        color="primary"
        onClick={() => push("/dashboard/projects/profit/" + row.Id)}
        title={<Translator id="calculate_pr_lo" noSpan />}
        className="w-100"
      />
    ),
    classes: "normal",
    headerClasses: "actionBtn",
    editable: false,
  },
];

//!------ SUPER-ADMIN
export const satc_customers = [
  {
    dataField: "num",
    text: "",
    align: "right",
    headerAlign: "right",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="customerName" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "infos",
    text: "",
    formatter: (cell, row) => <Infos row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "periods",
    text: "",
    formatter: (cell, row) => <Periods row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "users",
    text: "",
    formatter: (cell, row) => <Users row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "limits",
    text: "",
    formatter: (cell, row) => <Limits row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "factors",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <Factors row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];
export const satc_periods = [
  {
    dataField: "num",
    text: "",
    align: "right",
    headerAlign: "right",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "Period",
    text: <Translator id="periodName" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "FromJalali",
    text: <Translator id="fromDate" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "ToJalali",
    text: <Translator id="toDate" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "Price",
    text: (
      <>
        <Translator id="price" noSpan /> (<Translator id="moneyUnit" noSpan />)
      </>
    ),
    formatter: (cell) => cell.toLocaleString(),
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "Active",
    text: <Translator id="status" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "right",
    headerAlign: "right",
    headerClasses: "status",
  },
  {
    dataField: "details",
    text: <Translator id="details" noSpan />,
    isDummyField: true,
    formatter: (cell, row) => <PeriodDetails row={row} />,
    align: "right",
    headerAlign: "right",
    classes: "normal",
    headerClasses: "action2",
    editable: false,
  },
];
export const satc_periodDetails = [
  {
    dataField: "num",
    text: "",
    align: "right",
    headerAlign: "right",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "Description",
    text: <Translator id="periodName" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "FromJalali",
    text: <Translator id="fromDate" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "ToJalali",
    text: <Translator id="toDate" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "Price",
    text: (
      <>
        <Translator id="price" noSpan /> (<Translator id="moneyUnit" noSpan />)
      </>
    ),
    formatter: (cell) => cell.toLocaleString(),
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "Active",
    text: <Translator id="status" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "right",
    headerAlign: "right",
    headerClasses: "status",
  },
  {
    dataField: "details",
    text: <Translator id="details" noSpan />,
    isDummyField: true,
    formatter: (cell, row) => <PeriodDetails row={row} />,
    align: "right",
    headerAlign: "right",
    classes: "normal",
    headerClasses: "action2",
    editable: false,
  },
];
export const satc_periodDetailsHistory = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "JalaliDate",
    text: <Translator id="date" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "TypeAddId",
    text: <Translator id="type" noSpan />,
    formatter: TypeAddFormatter,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "Group",
    text: <Translator id="group" noSpan />,
    formatter: IncreaseGroupFormatter,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "Description",
    text: <Translator id="description" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "Value",
    text: <Translator id="value" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "PriceUnit",
    text: (
      <>
        <Translator id="unitPrice" noSpan /> (
        <Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    editable: false,
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "Price",
    text: (
      <>
        <Translator id="price" noSpan /> (<Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    editable: false,
    formatter: (cell) => cell.toLocaleString(),
  },
];

export const satc_periodDetailsPayments = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "JalaliDate",
    text: <Translator id="date" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "TypeId",
    text: <Translator id="sapd_payType" noSpan />,
    formatter: TypePayFormatter,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "Description",
    text: <Translator id="description" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "Price",
    text: (
      <>
        <Translator id="price" noSpan /> (<Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    editable: false,
    formatter: (cell) => cell.toLocaleString(),
  },
];
export const satc_users = [
  {
    dataField: "num",
    text: "",
    align: "right",
    headerAlign: "right",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "UserName",
    text: <Translator id="userName" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "DisplayName",
    text: <Translator id="displayName" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "PhoneNumber",
    text: <Translator id="phoneNumber" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "Email",
    text: <Translator id="email" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "Role",
    text: <Translator id="role" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "IsActiveWithAdminPermisson",
    text: <Translator id="IsActiveWithAdminPermisson" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell, null, true),
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "IsDisableWithSuperAdminPermisson",
    text: <Translator id="IsDisableWithSuperAdminPermisson" noSpan />,
    formatter: (cell) => StatusFormatterIcons(!cell),
    align: "right",
    headerAlign: "right",
    editor: {
      type: Type.CHECKBOX,
      value: "false:true",
    },
    editable: true, //! add access level later
  },
];
export const satc_paymentDetailsColumn = [
  {
    dataField: "num",
    text: "",
    align: "right",
    headerAlign: "right",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "Description",
    text: <Translator id="description" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "Group",
    text: <Translator id="group" noSpan />,
    formatter: IncreaseGroupFormatter,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Value",
    text: <Translator id="value" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "PriceUnit",
    text: (
      <>
        <Translator id="unitPrice" noSpan /> (
        <Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "Price",
    text: (
      <>
        <Translator id="price" noSpan /> (<Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
];
export const satc_groupLimits = [
  {
    dataField: "num",
    text: "",
    align: "right",
    headerAlign: "right",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="sali_Name" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "BuyCount",
    text: <Translator id="sali_BuyCount" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "UsedCount",
    text: <Translator id="sali_UsedCount" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "RequestCount",
    text: <Translator id="sali_RequestCount" noSpan />,
    align: "right",
    headerAlign: "right",
    editorClasses: "inputEditor",
    validator: (newValue) => CheckTableValidation(newValue, { number: true }),
    editable: true, //! add access level later
  },
];
export const satc_factor = [
  {
    dataField: "num",
    text: "",
    align: "right",
    headerAlign: "right",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="sali_Name" noSpan />,
    align: "right",
    headerAlign: "right",
    editable: false,
  },
  {
    dataField: "IsActive",
    text: <Translator id="safa_IsActive" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "IsRequest",
    text: <Translator id="safa_IsRequest" noSpan />,
    formatter: (cell, row) => StatusFormatterIcons(cell, row),
    align: "center",
    headerAlign: "center",
    editor: {
      type: Type.CHECKBOX,
      value: "true:false",
    },
    editable: (content, row) => !row.IsActive, //! add access level later
  },
];
export const satc_priceSupervisor = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "Period",
    text: <Translator id="periodName" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "PriceUnit",
    text: (
      <>
        <Translator id="unitPrice" noSpan /> (
        <Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "IsPercentDiscount",
    text: <Translator id="percentageDiscount" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "ValueDiscount",
    text: (
      <>
        <Translator id="discount" noSpan /> (
        <Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "IsDiscountForeachCounter",
    text: <Translator id="stepDiscount" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "MaxValueDiscount",
    text: (
      <>
        <Translator id="maxDiscount" noSpan /> (
        <Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <EditSupervisor row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    formatter: (cell, row) => <DeleteSupervisor row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];
export const satc_priceService = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "Period",
    text: <Translator id="periodName" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Service",
    text: <Translator id="serviceName" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "PriceUnit",
    text: (
      <>
        <Translator id="unitPrice" noSpan /> (
        <Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "IsPercentDiscount",
    text: <Translator id="percentageDiscount" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "ValueDiscount",
    text: (
      <>
        <Translator id="discount" noSpan /> (
        <Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "IsDiscountForeachCounter",
    text: <Translator id="stepDiscount" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "MaxValueDiscount",
    text: (
      <>
        <Translator id="maxDiscount" noSpan /> (
        <Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <EditPriceServices row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    formatter: (cell, row) => <DeletePriceServices row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];
export const satc_priceProduct = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "Period",
    text: <Translator id="periodName" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Product",
    text: <Translator id="productName" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "MinCount",
    text: <Translator id="minCount" noSpan />,
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "5%" },
  },
  {
    dataField: "MaxCount",
    text: <Translator id="maxCount" noSpan />,
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "5%" },
  },
  {
    dataField: "PriceUnit",
    text: (
      <>
        <Translator id="unitPrice" noSpan /> (
        <Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "IsPercentDiscount",
    text: <Translator id="percentageDiscount" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "ValueDiscount",
    text: (
      <>
        <Translator id="discount" noSpan /> (
        <Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "IsDiscountForeachCounter",
    text: <Translator id="stepDiscount" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "MaxValueDiscount",
    text: (
      <>
        <Translator id="maxDiscount" noSpan /> (
        <Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <EditPriceProducts row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    formatter: (cell, row) => <DeletePriceProducts row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];
export const satc_priceFactor = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "Period",
    text: <Translator id="periodName" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Factor",
    text: <Translator id="factorName" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "PriceUnit",
    text: (
      <>
        <Translator id="unitPrice" noSpan /> (
        <Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "IsPercentDiscount",
    text: <Translator id="percentageDiscount" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "ValueDiscount",
    text: (
      <>
        <Translator id="discount" noSpan /> (
        <Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "IsDiscountForeachCounter",
    text: <Translator id="stepDiscount" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "MaxValueDiscount",
    text: (
      <>
        <Translator id="maxDiscount" noSpan /> (
        <Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <EditPriceFactors row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    formatter: (cell, row) => <DeletePriceFactors row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];
export const satc_pricePeriod = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="periodName" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Days",
    text: <Translator id="dayCount" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "IsActive",
    text: <Translator id="isActivePeriod" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "IsDefault",
    text: <Translator id="isPeriod" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "Order",
    text: <Translator id="order" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <EditPricePeriods row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    formatter: (cell, row) => <DeletePricePeriods row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];
export const satc_accountingFinancial = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "Order",
    text: <Translator id="invoice_number" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "JalaliDate",
    text: <Translator id="saaf_JalaliDate" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Group",
    text: <Translator id="group" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Price",
    text: (
      <span>
        <Translator id="price" noSpan /> (<Translator id="moneyUnit" noSpan />)
      </span>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
    headerStyle: { width: "10%" },
  },
  {
    dataField: "Type",
    text: <Translator id="saaf_Type" noSpan />,
    formatter: (cell) => FinancialType(cell),
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "RetrivalRefNo",
    text: <Translator id="payment_reference_number" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "SystemTraceNo",
    text: <Translator id="payment_tracking_number" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Describ",
    text: <Translator id="description" noSpan />,
    align: "center",
    headerAlign: "center",
  },
];
export const satc_accountingHistoryIncTime = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "UserRegister",
    text: <Translator id="sati_UserRegister" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "TimeRegister",
    text: <Translator id="satc_DateJalali" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Description",
    text: <Translator id="description" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Inc",
    text: <Translator id="sati_Inc" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "",
    text: "",
    formatter: (cell, row) => <IncTimeGroup row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];
export const satc_accountingHistoryIncTimeGroup = [
  {
    dataField: "GroupId",
    text: <Translator id="sati_GroupId" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Group",
    text: <Translator id="group" noSpan />,
    align: "center",
    headerAlign: "center",
  },
];
export const satc_accountingHistoryActive = [
  {
    dataField: "IdGroup",
    text: <Translator id="sati_GroupId" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Group",
    text: <Translator id="group" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "ExpireJalali",
    text: <Translator id="sati_ExpireJalali" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "IsFree",
    text: <Translator id="sati_IsFree" noSpan />,
    formatter: (cell) => StatusIsFree(cell),
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Period",
    text: <Translator id="periodName" noSpan />,
    align: "center",
    headerAlign: "center",
  },
];
export const satc_DefaultPanel = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "Period",
    text: <Translator id="periodName" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Name",
    text: <Translator id="safd_Name" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "ProductCount",
    text: <Translator id="productCount" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "IsActive",
    text: <Translator id="isActivePeriod" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "IsDefault",
    text: <Translator id="isPeriod" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <EditDefaultPanel row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    formatter: (cell, row) => <DeleteDefaultPanel row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];
export const satc_DefaultCharge = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "Title",
    text: <Translator id="title" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Price",
    text: (
      <span>
        <Translator id="price" noSpan /> (<Translator id="moneyUnit" noSpan />)
      </span>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "PriceCredit",
    text: (
      <span>
        <Translator id="priceCredit" noSpan /> (
        <Translator id="moneyUnit" noSpan />)
      </span>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
  },
  {
    dataField: "Describ",
    text: <Translator id="description" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
    // headerStyle: { width: "10%" },
  },
  {
    dataField: "Active",
    text: <Translator id="isActivePeriod" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <EditDefaultCharge row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    formatter: (cell, row) => <DeleteDefaultCharge row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];
export const satc_accountingManualCredit = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "GroupId",
    text: <Translator id="sati_GroupId" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Group",
    text: <Translator id="group" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Type",
    text: <Translator id="method" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Method",
    text: <Translator id="satc_Method" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "DateJalali",
    text: <Translator id="satc_DateJalali" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Price",
    text: (
      <>
        <Translator id="price" noSpan /> (<Translator id="moneyUnit" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
    // headerStyle: { width: "10%" },
  },
  {
    dataField: "Describ",
    text: <Translator id="description" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
    // headerStyle: { width: "10%" },
  },
  {
    dataField: "Isinc",
    text: <Translator id="satc_Isinc" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "center",
    headerAlign: "center",
    editable: false,
  },
];
export const satc_DiscountCard = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "Period",
    text: <Translator id="periodName" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Stype",
    text: <Translator id="sadc_Stype" noSpan />,
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "7%" },
  },
  {
    dataField: "Refrence",
    text: <Translator id="sadc_Refrence" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Group",
    text: <Translator id="group" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Code",
    text: <Translator id="discountCode" noSpan />,
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "7%" },
  },
  {
    dataField: "From",
    text: <Translator id="fromDate" noSpan />,
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "7%" },
  },
  {
    dataField: "To",
    text: <Translator id="toDate" noSpan />,
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "7%" },
  },
  {
    dataField: "IsPercent",
    text: <Translator id="percentageDiscount" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "center",
    headerAlign: "center",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "Value",
    text: (
      <>
        <Translator id="value" noSpan /> (<Translator id="moneyUnit" noSpan />/
        <Translator id="percent" noSpan />)
      </>
    ),
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
    headerStyle: { width: "7%" },
  },
  {
    dataField: "MinBuy",
    text: <Translator id="sadc_MinBuy" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell) => cell.toLocaleString(),
    headerStyle: { width: "7%" },
  },
  {
    dataField: "UsableCount",
    text: <Translator id="sadc_UsableCount" noSpan />,
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "7%" },
  },
  {
    dataField: "IsActive",
    text: <Translator id="active" noSpan />,
    formatter: (cell) => StatusFormatterIcons(cell),
    align: "center",
    headerAlign: "center",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "CountUsed",
    text: <Translator id="sadc_CountUsed" noSpan />,
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "5%" },
  },
  {
    dataField: "edit",
    text: "",
    formatter: (cell, row) => <EditDiscountCard row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    formatter: (cell, row) => <DeleteDiscountCard row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "",
    text: "",
    formatter: (cell, row) => <UsedGroup row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];
export const satc_DiscountCardUsed = [
  {
    dataField: "num",
    text: "",
    align: "right",
    headerAlign: "right",
    headerStyle: { width: "5%" },
    editable: false,
  },
  {
    dataField: "GroupId",
    text: <Translator id="sati_GroupId" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "Group",
    text: <Translator id="group" noSpan />,
    align: "right",
    headerAlign: "right",
  },
  {
    dataField: "JalaliDate",
    text: <Translator id="date" noSpan />,
    align: "right",
    headerAlign: "right",
  },
];
export const sa_ticketColumn = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "DateRegister",
    text: <Translator id="date" noSpan />,
    align: "center",
    headerAlign: "center",
    headerClasses: "date-show",
  },
  {
    dataField: "Group",
    text: <Translator id="group" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "User",
    text: <Translator id="user" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Title",
    text: <Translator id="title" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "GroupTicket",
    text: <Translator id="ticketSubset" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Status",
    text: <Translator id="status" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell, row) => <TicketStatusFormatter cell={cell} row={row} />,
  },
  {
    dataField: "",
    text: "",
    formatter: (cell, row) => <ShowTicket row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const sa_NoticeColumn = [
  {
    dataField: "num",
    text: "",
    align: "center",
    headerAlign: "center",
    editable: false,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "Title",
    text: <Translator id="title" noSpan />,
    align: "center",
    headerAlign: "center",
    headerClasses: "date-show",
  },
  {
    dataField: "DateRegister",
    text: <Translator id="messageDate" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell) => {
      return <>{cell.split("-")[0]}</>;
    },
  },
  {
    dataField: "User",
    text: <Translator id="user" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "GroupNotice",
    text: <Translator id="group" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "IsActive",
    text: <Translator id="status" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell) => StatusFormatter(cell),
    editable: false,
  },
  {
    dataField: "DateExpire",
    text: <Translator id="sati_ExpireJalali" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell) => {
      return <>{cell.split("-")[0]}</>;
    },
  },
  {
    dataField: "manage",
    text: "",
    formatter: (cell, row) => <NoticeDetails row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
  },
  {
    dataField: "",
    text: "",
    formatter: (cell, row) => <NoticeReader row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
  },
  {
    dataField: "",
    text: "",
    formatter: (cell, row) => <NoticeDelete row={row} />,
    align: "center",
    classes: "normal",
    headerClasses: "action",
  },
];

export const sa_NoticeReader = [
  {
    dataField: "User",
    text: <Translator id="user" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "IsDelete",
    text: <Translator id="isDelete" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell) => StatusFormatterIcons(cell, null),
  },
  {
    dataField: "IsRead",
    text: <Translator id="read" noSpan />,
    align: "center",
    headerAlign: "center",
    formatter: (cell) => StatusFormatterIcons(cell, null),
  },
];

export const patternGroupColumn = [
  {
    dataField: "Name",
    text: <Translator id="NameGroup" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    editable: false,
  },
  {
    dataField: "Type",
    text: <Translator id="type" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    editable: false,
  },
  {
    dataField: "Struct",
    text: <Translator id="struct" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    editable: false,
  },
  {
    dataField: "StructFrame",
    text: <Translator id="structFrame" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    editable: false,
  },
  {
    dataField: "list",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <TemplateIndex row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "edit",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <EditPatternGroup row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeletePatternGroup row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const TemplateColumn = [
  {
    dataField: "Template",
    text: <Translator id="Template" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    editable: false,
  },
  {
    dataField: "Description",
    text: <Translator id="description" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    editable: false,
  },
];

export const settingGlassColumn = [
  {
    dataField: "ShowName",
    text: <Translator id="name" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    editable: false,
  },
  {
    dataField: "Group",
    text: <Translator id="glassGroup" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    editable: false,
  },
  {
    dataField: "Name",
    text: <Translator id="glass" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    editable: false,
  },
  {
    dataField: "Description",
    text: <Translator id="description" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    editable: false,
  },
  {
    dataField: "edit",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <EditGlass row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeleteGlass row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const settingProjectsColumn = [
  {
    dataField: "Name",
    text: <Translator id="name" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    editable: false,
  },
  {
    dataField: "Project",
    text: <Translator id="projectName" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    editable: false,
  },
  {
    dataField: "Type",
    text: <Translator id="type" noSpan />,
    align: "center",
    headerAlign: "center",
    editorClasses: "inputEditor",
    editable: false,
  },
  {
    dataField: "edit",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <EditProjects row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "delete",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <DeleteProjects row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const settingSelectedProject = [
  {
    dataField: "Image",
    text: <Translator id="Image" noSpan />,
    align: "right",
    headerAlign: "right",
    formatter: (cell) => <ImageBox image={`data:image/png;base64, ${cell}`} />,
    headerClasses: "image",
  },
  {
    dataField: "Name",
    text: <Translator id="nameUnit" noSpan />,
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "15%" },
    formatter: (cell, row) => <NameFormatter row={row} cell={cell} />,
  },
  {
    dataField: "HUnit",
    text: <Translator id="sizeV2" noSpan />,
    align: "right",
    headerAlign: "right",
    classes: "number",
    formatter: (cell, row) => (
      <span className="normalTitle">{`${row.WUnit} x  ${cell}`}</span>
    ),
    headerStyle: { width: "15%" },
  },
  {
    dataField: "TypeUnit",
    text: <Translator id="Structure" noSpan />,
    align: "right",
    headerAlign: "right",
    formatter: TagFormatter,
    headerClasses: "tag",
  },
  {
    dataField: "Location",
    text: <Translator id="placeLocation" noSpan />,
    align: "right",
    headerAlign: "right",
    formatter: (cell) => <p>{cell ? cell : "---"}</p>,
  },
  {
    dataField: "edit",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <ProjectUnitInfo row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
  {
    dataField: "edit",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => <ProjectUnitDetails row={row} />,
    align: "right",
    classes: "normal",
    headerClasses: "action",
    editable: false,
  },
];

export const managePartCountColumn = [
  {
    dataField: "NameUnit",
    text: <Translator id="nameUnit" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: false,
  },
  {
    dataField: "Length",
    text: <Translator id="pieceLength" noSpan />,
    align: "center",
    headerAlign: "center",
  },
  {
    dataField: "Angle1",
    text: <Translator id="angles" noSpan />,
    align: "center",
    headerAlign: "center",
    classes: "number",
    formatter: (cell, row) => (
      <span className="normalTitle">{`${row.Angle2} x  ${cell}`}</span>
    ),
    editable: false,
  },
  {
    dataField: "CountPiece",
    text: <Translator id="pieceCount" noSpan />,
    align: "center",
    headerAlign: "center",
    editable: true,
    editorClasses: "inputEditor",
    inputType: "number",
  },
];
